/*
 * Author: Harper Yan
 * File Created: Friday, 24-07-19 02:40 pm
 * Last Modified: Monday, 25-05-19 10:54 am, by Dw
 */

import { ComponentType } from 'react';

import { MessageComponentProps } from '../@type';
import store from './store';
import { StatusDialog } from './templates';
import { StatusDialogProps } from './templates/StatusDialog';

const { getState, setState, subscribe, getInitialState } = store;

export const showDialog = getState().show;
export const showDialogAsync = getState().showAsync;
export const hideDialog = getState().hide;
export const destroyDialog = getState().destroy;
export const clearDialogs = getState().clear;

export const showStatusDialog = (
  props: MessageComponentProps<StatusDialogProps>
) => getState().show<StatusDialogProps>(StatusDialog, props);
